import React, { useEffect, useState, useRef } from "react";
import { Table, Tooltip, Col, Form, Input, Tabs, Row } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import ImageUploading from "react-images-uploading";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { URL } from "../../Redux/common/url";
import Select from "react-select";
import TabPane from "antd/lib/tabs/TabPane";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReactToPrint from "react-to-print";
function PlotDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const users_list = useSelector((state) =>
    state?.allapi?.get_sub_category ? state?.allapi?.get_sub_category : {}
  );
  const get_main_all_category = useSelector((state) =>
    state?.allapi?.get_main_all_category
      ? state?.allapi?.get_main_all_category
      : []
  );
  const componentRef = useRef();
  console.log(users_list);

  const listdata = users_list?.docs ? users_list?.docs : [];

  const [subList, setsubList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const dropList = get_main_all_category?.map((data, i) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    setsubList(dropList);
  }, [get_main_all_category]);

  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [showDelelt, setShowDelete] = useState(false);
  const [showDelelt8, setShowDelete8] = useState(false);

  const handleCloseDelete = () => setShowDelete(false);
  const [cateID, setcateID] = useState("");

  const hendleDelete = async (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    await dispatch(
      allapiAction.deleteDocuments({ productId: e, pageNo: page })
    );
    // dispatch(adminAction.getRoleList('dhsg'))
    getDate();
    return () => {};
  };
  const hendleDelete8 = async (e) => {
    console.log(e);
    // deleteProduct
    setShowDelete(false);
    await dispatch(
      allapiAction.deleteProductseller({ productId: e, pageNo: page })
    );
    // dispatch(adminAction.getRoleList('dhsg'))
    getDate();
    return () => {};
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addModalOpen4, setAddModalOpen4] = useState(false);
  const [addModalOpen1, setAddModalOpen1] = useState(false);
  const [addModalOpen2, setAddModalOpen2] = useState(false);
  const [addModalOpen3, setAddModalOpen3] = useState(false);
  const [addModalOpen5, setAddModalOpen5] = useState(false);

  const hendleModalShow = (e) => {
    // setShowDelete(true)
    setcateID(e);
    setIsModalOpen(true);
  };

  const [cateDetail, setcateDetail] = useState({});
  const [cateDetail1, setcateDetail1] = useState({});
  const [cateDetail2, setcateDetail2] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);

  const [images, setImages] = useState([]);
  const maxNumber = 1;

  console.log(images);

  const [Imagesfe, setImagesfe] = useState("");
  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log(imageList, addUpdateIndex)
    setImagesfe(imageList);
  };

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  const [selectedOptionUpdate, setSelectedOptionUpdate] = useState(null);

  const hendleTochangeCategory = (e) => {
    const { name, value } = e.target;
    setcateDetail({ ...cateDetail, [name]: value });
  };

  const showModal = (e) => {
    console.log(e);
    setcateDetail(e);
    const selectCate = subList.find((edata) => edata?._id == e?.parentId?._id);

    setSelectedOptionUpdate(selectCate);
    setImagesfe([{ data_url: URL.API_BASE_URL + e.image }]);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    const data = new FormData();
    data.append("name", cateDetail?.name);
    // data.append('description', categoryUpPage)
    data.append("meta_title", cateDetail?.meta_title);
    data.append("meta_description", cateDetail?.meta_description);
    data.append("cate_id", cateDetail?._id);
    data.append("parentId", selectedOptionUpdate?._id);
    data.append("admin_commisstion", cateDetail?.admin_commisstion);
    data.append("pageNo", page);
    if (Imagesfe[0]?.file) {
      // roledata?.role_name
      data.append("image", Imagesfe[0]?.file);
    }
    dispatch(allapiAction.updateperentsubCate(data));
    // dispatch(
    //   allapiAction.updateperentsubCate({
    //     name: cateDetail?.name,
    //     // description: categoryUpPage,
    //     meta_title: cateDetail?.meta_title,
    //     meta_description: cateDetail?.meta_description,
    //     admin_commisstion: cateDetail?.admin_commisstion,
    //     parentId: selectedOptionUpdate?._id,
    //     pageNo: page,
    //     cate_id: cateDetail?._id,
    //   })
    // );
    // dispatch(adminAction.getRoleList('dhsg'))
    setIsModalOpen(false);
    return () => {};
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [cateDetailAdd, setcateDetailAdd] = useState({});
  console.log(cateDetailAdd);

  const hendleTochangeCategoryAdd = (e) => {
    const { name, value } = e.target;
    console.log(name);

    if (name == "lengths") {
      const area = (cateDetailAdd?.widths * value) / 9;
      console.log(area);

      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else if (name == "widths") {
      const area = (cateDetailAdd?.lengths * value) / 9;
      setcateDetailAdd((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else {
      setcateDetailAdd({ ...cateDetailAdd, [name]: value });
    }
  };
  const hendleTochangefiles = (e) => {
    const { name, files } = e.target;

    setSelectedFile(files);
    setcateDetail2({ ...cateDetail2, [name]: files });
  };
  const hendleTochangeCategoryAdd1 = (e) => {
    const { name, value } = e.target;
    console.log(name);

    if (name == "lengths") {
      const area = (cateDetail1?.widths * value) / 9;
      console.log(area);

      setcateDetail1((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else if (name == "widths") {
      const area = (cateDetail1?.lengths * value) / 9;
      setcateDetail1((prevState) => ({
        ...prevState,
        area: area,
        [name]: value,
      }));
      // setcateDetailAdd({ ...cateDetailAdd, ["area"]: area });
    } else {
      setcateDetail1({ ...cateDetail1, [name]: value });
    }
  };

  const showModalAdd = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen(true);
  };
  const showModalAdd4 = (e) => {
    console.log(e);
    setcateDetail(e);
    setAddModalOpen4(true);
  };
  const showModalAdd2 = (e) => {
    console.log(e);
    setcateDetail2(e);
    setAddModalOpen2(true);
  };
  const showModalAdd1 = (e) => {
    console.log(e);

    if (e?.lengthWidth) {
      const [lengths, widths] = e.lengthWidth.split("x");
      e.lengths = lengths;
      e.widths = widths;
    }

    setcateDetail1(e);
    setAddModalOpen1(true);
  };
  const [startDate, setStartDate] = useState(new Date());
  const [aboutPage, setaboutPage] = useState("");
  const handleOkAdd = async () => {
    if (!cateDetailAdd?.fullName) {
      toast.error("please enter name");
    } else if (!cateDetailAdd?.fatharYaHusband) {
      toast.error("please enter fathar/Husband");
    } else if (!cateDetailAdd?.rasidNo) {
      toast.error("please enter recept No");
    } else {
      const data = new FormData();
      // data.append("page", 1);
      // data.append("name", cateDetailAdd?.name);
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);
      if (cateDetailAdd?.lengths) {
        cateDetailAdd.lengthWidth =
          cateDetailAdd?.lengths + "x" + cateDetailAdd?.width;
      }
      //   data.append("sellinDate", startDate.toISOString().split("T")[0]);
      cateDetailAdd.plotId = id;
      cateDetailAdd.sellinDate = startDate.toISOString().split("T")[0];
      const response = await dispatch(allapiAction.AddOwner(cateDetailAdd));

      if (response?.success) {
        getDate();
        // setcateDetailAdd({
        //   type: "",
        //   number: "",
        //   area: "",
        //   lengths: "",
        //   widths: "",
        // });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };
  const handleOkAdd4 = async () => {
    if (!cateDetailAdd?.fullName) {
      toast.error("please enter name");
    } else if (!cateDetailAdd?.fatharYaHusband) {
      toast.error("please enter fathar/Husband");
    } else if (!cateDetailAdd?.rasidNo) {
      toast.error("please enter recept No");
    } else {
      const data = new FormData();
      // data.append("page", 1);
      // data.append("name", cateDetailAdd?.name);
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);
      if (cateDetailAdd?.lengths) {
        cateDetailAdd.lengthWidth =
          cateDetailAdd?.lengths + "x" + cateDetailAdd?.width;
      }
      //   data.append("sellinDate", startDate.toISOString().split("T")[0]);
      cateDetailAdd.plotId = id;
      cateDetailAdd.sellinDate = startDate.toISOString().split("T")[0];
      const response = await dispatch(
        allapiAction.OwnerTransfar(cateDetailAdd)
      );

      if (response?.success) {
        getDate();
        // setcateDetailAdd({
        //   type: "",
        //   number: "",
        //   area: "",
        //   lengths: "",
        //   widths: "",
        // });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen4(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };
  const handleOkAddDocument = async () => {
    if (!cateDetail2?.images) {
      toast.error("please select document");
    } else if (cateDetail2?.images?.length == 0) {
      toast.error("please select document");
    } /* else if (!cateDetailAdd?.rasidNo) {
      toast.error("please enter recept No");
    } */ else {
      const data = new FormData();
      // data.append("page", 1);
      data.append("propertyId", id);
      console.log(cateDetail2?.images);
      console.log(selectedFile);
      console.log(cateDetail2?.images?.FileList);

      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("images", selectedFile[i]);
      }

      // selectedFile?.map((e, i) => {
      //   console.log(e);

      //   data.append("images", e);
      // });
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);

      const response = await dispatch(allapiAction.propertyDocumentAdd(data));

      if (response?.success) {
        getDate();
        // setcateDetailAdd({
        //   type: "",
        //   number: "",
        //   area: "",
        //   lengths: "",
        //   widths: "",
        // });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen2(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };
  const handleOkAdd1 = async () => {
    if (!cateDetail1?.type) {
      toast.error("please enter type");
    } else if (!cateDetail1?.number) {
      toast.error("please enter number");
    } else if (!cateDetail1?.area) {
      toast.error("please enter area");
    } else {
      const data = new FormData();
      // data.append("page", 1);
      // data.append("name", cateDetailAdd?.name);
      // // data.append('description', aboutPage)
      // data.append("meta_title", cateDetailAdd?.meta_title);
      // data.append("meta_description", cateDetailAdd?.meta_description);
      // data.append("categoryName", "test cate");
      // data.append("parentId", selectedOption?._id);
      // data.append("sellerId", "20");
      // data.append("image", images[0]?.file);
      if (cateDetail1?.lengths) {
        cateDetail1.lengthWidth =
          cateDetail1?.lengths + "x" + cateDetail1?.widths;
      }

      cateDetail1.plotId = id;
      const response = await dispatch(allapiAction.EditPlot(cateDetail1));

      if (response?.success) {
        getDate();
        // setcateDetailAdd({
        //   type: "",
        //   number: "",
        //   area: "",
        //   lengths: "",
        //   widths: "",
        // });
        // dispatch(adminAction.getRoleList('dhsg'))
        setAddModalOpen1(false);
      }
      // dispatch(
      //   allapiAction.subcreateCategory({
      //     name: cateDetailAdd?.name,

      //     meta_title: cateDetailAdd?.meta_title,
      //     meta_description: cateDetailAdd?.meta_description,
      //     admin_commisstion: cateDetailAdd?.admin_commisstion,
      //     parentId: selectedOption?._id,
      //   })
      // );

      return () => {};
    }
  };
  const handleCancelAdd = () => {
    setAddModalOpen(false);
  };

  const handleCancelAdd4 = () => {
    setAddModalOpen4(false);
  };
  const handleCancelAdd2 = () => {
    setAddModalOpen2(false);
  };
  const handleCancelAdd3 = () => {
    setAddModalOpen3(false);
  };
  const handleCancelAdd5 = () => {
    setAddModalOpen5(false);
  };
  const handleCancelAdd1 = () => {
    setAddModalOpen1(false);
  };

  const { confirm } = Modal;

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showDeleteConfirm8 = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "you want to delete this plot?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete8(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusSubCategory({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //       <div style={{width:"100px"}}>
    //         <img  style={{width:"100%"}} src={URL?.API_BASE_URL +item?.image} alt="" />
    //       </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "100px" }}>
              <img
                style={{ width: "100%" }}
                src={URL?.API_BASE_URL + item?.image}
                alt=""
              />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "table_action_col",
    },
    {
      title: "admin commisstion",
      dataIndex: "admin_commisstion",
      key: "admin_commisstion",
      className: "table_action_col",
    },

    {
      title: "Perent Category",
      dataIndex: "parentId",
      key: "parentId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Contact"> */}
            <span
              className="cursor-pointer "
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.parentId?.name}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   key: "email",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title={item?.status}>
              <button
                className={
                  item?.is_status == "Active"
                    ? "success-button ml-3"
                    : "delete-button ml-3"
                }
                onClick={() =>
                  hendleToStatus(
                    item?._id,
                    item?.is_status == "Active" ? "Inactive" : "Active"
                  )
                }
              >
                {item?.is_status}
              </button>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    // dispatch(allapiAction.getsubCategoryList(1));
    // dispatch(allapiAction.getcateAllList({}));
    getDate();
    return () => {};
  }, []);

  const [details, setdetails] = useState({});

  console.log(details);

  const ownerLsit = details?.ownerList ? details?.ownerList : [];
  const currentOwnerList = ownerLsit?.filter(
    (item) => item?.plotStatus === "Current"
  );
  const pastOwnerList = ownerLsit?.filter(
    (item) => item?.plotStatus !== "Current"
  );

  const getDate = async () => {
    const response = await dispatch(allapiAction.getPlotDetails(id));

    if (response?.success) {
      setdetails(response?.data);
    }
  };

  // const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const handleChange = (e) => {
    console.log(e);
    setsearch(e);
    setPage(1);
    if (e) {
      dispatch(allapiAction.allcategorySearch({ page: 1, search: e }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(1));

      return () => {};
    }
    // getuserListSearch
    // &user_id=${data?.user_id}&search=${data?.user_id}
  };

  const hendlePahegi = (e) => {
    setPage(e);
    if (search) {
      dispatch(allapiAction.allcategorySearch({ page: e, search: search }));
      return () => {};
    } else {
      dispatch(allapiAction.getsubCategoryList(e));

      return () => {};
    }
  };

  return (
    <div>
      {/* update */}
      <Modal
        title="Update Category"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <ImageUploading
            // multiple
            value={Imagesfe}
            onChange={onChangefe}
            maxNumber={maxNumber}
            dataURLKey="data_url"
            acceptType={["png", "jpeg", "jpg", "webp"]}
            // acceptType={['jpg']}
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageUpdate,
              onImageRemove,
              isDragging,
              dragProps,
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <button
                  style={isDragging ? { color: "red" } : {}}
                  onClick={onImageUpload}
                  {...dragProps}
                  className="btn btn-secondary"
                >
                  Choose image
                </button>
                &nbsp;
                {/* <button
                  className="btn btn-secondary"
                  onClick={onImageRemoveAll}
                >
                  Remove all images
                </button> */}
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.data_url} alt="" width="100" />
                    <div className="image-item__btn-wrapper">
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageUpdate(index)}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => onImageRemove(index)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ImageUploading>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Select
            value={selectedOptionUpdate}
            onChange={setSelectedOptionUpdate}
            options={subList}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="name"
            name="name"
            value={cateDetail?.name}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="admin commisstion"
            name="admin_commisstion"
            value={cateDetail?.admin_commisstion}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta title"
            name="meta_title"
            value={cateDetail?.meta_title}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>

        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="new-off"
            className="form-control mt-8"
            placeholder="meta description"
            name="meta_description"
            value={cateDetail?.meta_description}
            onChange={(e) => {
              hendleTochangeCategory(e);
            }}
          />
        </Col>
      </Modal>
      <Modal
        title="Edit Plot/shop"
        open={addModalOpen1}
        onOk={handleOkAdd1}
        onCancel={handleCancelAdd1}
      >
        <Row>
          {/* <Col lg={24} md={24} sm={24} xs={24}>
          <Select
            value={selectedOption}
            onChange={setSelectedOption}
            options={subList}
          />
        </Col> */}
          <Col lg={24} md={24} sm={24} xs={24}>
            Please Choose
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <select
              className="form-control mt-8"
              name="type"
              value={cateDetail1?.type}
              onChange={(e) => {
                hendleTochangeCategoryAdd1(e);
              }}
            >
              <option value="">Choose</option>
              <option value="Shop">Shop</option>
              <option value="Plot">Plot</option>
            </select>
            {/* <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="name"
              name="name"
              value={cateDetailAdd?.name}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            /> */}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Plot/Shop No.
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="number"
              name="number"
              value={cateDetail1?.number}
              onChange={(e) => {
                hendleTochangeCategoryAdd1(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            L X W Feet
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="length"
              name="lengths"
              type="number"
              value={cateDetail1?.lengths}
              onChange={(e) => {
                hendleTochangeCategoryAdd1(e);
              }}
            />
          </Col>{" "}
          <Col lg={2} md={2} sm={2} xs={2}>
            <div className="pt-15 text-center">
              <span>X</span>
            </div>
          </Col>
          <Col lg={11} md={11} sm={11} xs={11}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="width"
              name="widths"
              type="number"
              value={cateDetail1?.widths}
              onChange={(e) => {
                hendleTochangeCategoryAdd1(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            Area
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder=" area"
              name="area"
              type="number"
              value={cateDetail1?.area}
              onChange={(e) => {
                hendleTochangeCategoryAdd1(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
      {/* create */}
      <Modal
        className="plotDetailsMd"
        title="Add Owner"
        open={addModalOpen}
        onOk={handleOkAdd}
        onCancel={handleCancelAdd}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Owner Name</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Owner Name"
              name="fullName"
              value={cateDetailAdd?.fullName}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Father's/Husband's Name</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Father's/Husband's Name"
              name="fatharYaHusband"
              value={cateDetailAdd?.fatharYaHusband}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Contact Number</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Contact Number "
              name="contactNumber"
              value={cateDetailAdd?.contactNumber}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Address</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Address"
              name="Address"
              value={cateDetailAdd?.Address}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Receipt No.</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder=" Receipt No."
              name="rasidNo"
              value={cateDetailAdd?.rasidNo}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Reg. Date</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <DatePicker
              className="form-control mt-5"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
        </Row>
      </Modal>
      <Modal
        className="plotDetailsMd"
        title="Plot Tranasfer"
        open={addModalOpen4}
        onOk={handleOkAdd4}
        onCancel={handleCancelAdd4}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15">Owner Name</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Owner Name"
              name="fullName"
              value={cateDetailAdd?.fullName}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Father's/Husband's Name</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Father's/Husband's Name"
              name="fatharYaHusband"
              value={cateDetailAdd?.fatharYaHusband}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Contact Number</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Contact Number "
              name="contactNumber"
              value={cateDetailAdd?.contactNumber}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Address</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="Address"
              name="Address"
              value={cateDetailAdd?.Address}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Receipt No.</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder=" Receipt No."
              name="rasidNo"
              value={cateDetailAdd?.rasidNo}
              onChange={(e) => {
                hendleTochangeCategoryAdd(e);
              }}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Reg. Date</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <DatePicker
              className="form-control mt-5"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        className="plotDetailsMd"
        title="Add Document"
        open={addModalOpen2}
        onOk={handleOkAddDocument}
        onCancel={handleCancelAdd2}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div className=" mr-5 mt-15"> Select Document</div>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <input
              autoComplete="new-off"
              className="form-control mt-8"
              placeholder="images"
              name="images"
              type="file"
              accept="image/*"
              multiple
              // value={cateDetailAdd?.fullName}
              onChange={(e) => {
                hendleTochangefiles(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
      <Modal
        className="plotDetailsMd"
        title="View Document"
        open={addModalOpen3}
        onOk={handleCancelAdd3}
        onCancel={handleCancelAdd3}
        width={800}
      >
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            {details?.documents &&
              details?.documents?.map((data, i) => {
                return (
                  <div className=" mr-5 mt-15">
                    {data?.type == "pdf" ? (
                      <div style={{ height: "500px" }}>
                        <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip>
                        <iframe
                          src={URL.API_BASE_URL + data?.document}
                          width="100%"
                          height="100%"
                          title="PDF Viewer"
                          style={{ border: "none" }}
                        />
                      </div>
                    ) : (
                      <div>
                        {" "}
                        <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip>
                        <img
                          src={URL.API_BASE_URL + data?.document}
                          alt=""
                          style={{ width: "100%" }}
                        />
                        {/* <a
                          href={URL.API_BASE_URL + data?.document}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          style={{
                            marginTop: "10px",
                            background: "#f5f5f5",
                            padding: "5px",
                          }}
                        >
                          Download
                          
                        </a> */}
                      </div>
                    )}
                    {/* Select Document */}
                  </div>
                );
              })}
          </Col>
        </Row>
      </Modal>
      <Modal
        className="plotDetailsMd"
        title="Print Document"
        open={addModalOpen5}
        onOk={handleCancelAdd5}
        onCancel={handleCancelAdd5}
        width={800}
      >
        <Row ref={componentRef}>
          <Col lg={24} md={24} sm={24} xs={24}>
            {details?.documents &&
              details?.documents?.map((data, i) => {
                return (
                  <div className=" mr-5 mt-15">
                    {data?.type == "pdf" ? (
                      <div style={{ height: "500px" }}>
                        <iframe
                          src={URL.API_BASE_URL + data?.document}
                          width="100%"
                          height="100%"
                          title="PDF Viewer"
                          style={{ border: "none" }}
                        />
                      </div>
                    ) : (
                      <div>
                        {/* <Tooltip title="Delete">
                          <span
                            className="cursor-pointer"
                            onClick={() => {
                              showDeleteConfirm(data?._id);
                            }}
                          >
                            <SvgIcon.deletebtn className="scale-icon edit-icon" />
                          </span>
                        </Tooltip> */}
                        <img
                          src={URL.API_BASE_URL + data?.document}
                          alt=""
                          style={{ width: "100%" }}
                        />

                        {/* <a
                          href={URL.API_BASE_URL + data?.document}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          style={{
                            marginTop: "10px",
                            background: "#f5f5f5",
                            padding: "5px",
                          }}
                        >
                          Download
                          
                        </a> */}
                      </div>
                    )}
                    {/* Select Document */}
                  </div>
                );
              })}
          </Col>
        </Row>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6">
            <ReactToPrint
              trigger={() => (
                <Button variant="primary">Print / Download</Button>
              )}
              content={() => componentRef.current}
            />
          </div>
        </div>
      </Modal>

      <div className="flex">
        <div>
          <HeadingBack
            title={" Details"}
            // subHeading={`Total ${users_list?.totalDocs || 0} Scheme Details`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        <div className="flex1 flex justify-content-end align-items-center">
          {/* <Tooltip title="Add">
            <span className="jop_btn" onClick={() => showModalAdd()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip> */}
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <div className="Shedow">
          <div className="SchecmeDetails">
            <div className="row">
              <div className="col-6">
                <p style={{ marginTop: "15px" }}>
                  <span style={{ fontWeight: "bold", marginTop: "15px" }}>
                    {details?.type} Details
                  </span>{" "}
                  :{" "}
                </p>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <span class="fw-bold">Scheme Name</span>

                    <span style={{ textTransform: "capitalize" }}>
                      {" "}
                      {details?.skimName}
                    </span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">{details?.type} No.</span>
                    <span> {details?.number}</span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">Area</span>
                    <span>
                      {" "}
                      {details?.area ? details?.area?.toFixed(2) : 0}
                    </span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">L X W Feet</span>
                    <span> {details?.lengthWidth}</span>
                  </li>

                  {/* <li class="list-group-item">
                    <span class="fw-bold">Recept No. </span>
                    <span class="fw-bold text--warning">  {details?.rasidNo}</span>
                  </li> */}
                </ul>
                <p>
                  <span style={{ fontWeight: "bold" }}>Current Owner</span> :{" "}
                </p>

                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <span class="fw-bold">Onwer Name</span>

                    <span> {details?.fullName}</span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">Father's/Husband's Name</span>
                    <span> {details?.fatharYaHusband}</span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">Address</span>
                    <span> {details?.Address}</span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">Mobile No.</span>
                    <span> {details?.contactNumber}</span>
                  </li>

                  <li class="list-group-item">
                    <span class="fw-bold">Recept No. </span>
                    <span class="fw-bold text--warning">
                      {" "}
                      {details?.rasidNo}
                    </span>
                  </li>
                  <li class="list-group-item">
                    <span class="fw-bold">Sell in Date </span>
                    <span>
                      {/* {moment(details?.sellinDate).format(" DD/MM/YYYY ")}{" "} */}
                      {details?.sellinDate ? 
                        moment(details?.sellinDate).format(" DD/MM/YYYY ") :
                      moment(details?.createdAt).format(" DD/MM/YYYY ")
                      }{" "}
                    </span>
                  </li>
                </ul>
              </div>

              <div className="col-4"></div>
              <div className="col-2">
                {details?.sold !== "Yes" && (
                  <Tooltip title="Add">
                    <span className="jop_btn" onClick={() => showModalAdd()}>
                      Add Owner
                    </span>
                  </Tooltip>
                )}
                {details?.sold == "Yes" && (
                  <Tooltip title="Add">
                    <span className="jop_btn" onClick={() => showModalAdd4()}>
                      Transfar
                    </span>
                  </Tooltip>
                )}
                <Tooltip title="Edit">
                  <span
                    className="jop_btn mt-3"
                    onClick={() => showModalAdd1(details)}
                  >
                    Edit Plot
                    {/* <SvgIcon.Add
                      width={40}
                      height={40}
                      className="cursor-pointer"
                    /> */}
                  </span>
                </Tooltip>
                <Tooltip title="Edit">
                  <span
                    className="jop_btn mt-3"
                    onClick={() => showModalAdd2(details)}
                  >
                    Add document
                  </span>
                </Tooltip>
                {details?.documents?.length > 0 && (
                  <Tooltip title="Edit">
                    <span
                      className="jop_btn mt-3"
                      onClick={() => setAddModalOpen3(true)}
                    >
                      View document
                    </span>
                  </Tooltip>
                )}
                {details?.documents?.length > 0 && (
                  <Tooltip title="Edit">
                    <span
                      className="jop_btn mt-3"
                      onClick={() => setAddModalOpen5(true)}
                    >
                      Print document
                    </span>
                  </Tooltip>
                )}
                <Tooltip title="Delete">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      showDeleteConfirm8(details?._id);
                    }}
                  >
                    <SvgIcon.deletebtn className="scale-icon edit-icon" />
                  </span>
                </Tooltip>
              </div>
              <div className="col-12">
                {currentOwnerList?.length > 0 && (
                  <p>
                    <span style={{ fontWeight: "bold" }}>Current Owner</span> :{" "}
                  </p>
                )}

                {currentOwnerList?.length > 0 && (
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr>
                        <td class="fw-bold">Onwer Name</td>
                        <td class="fw-bold">Father's/Husband's Name</td>
                        <td class="fw-bold">Address</td>
                        <td class="fw-bold">Mobile No.</td>
                        <td class="fw-bold">Recept No. </td>
                        <td class="fw-bold">Sell in Date </td>
                        <td class="fw-bold">View</td>
                      </tr>

                      {currentOwnerList &&
                        currentOwnerList?.map((data, i) => {
                          return (
                            <tr>
                              <td>{data?.userName}</td>
                              <td>{data?.userFather}</td>
                              <td>{data?.Address}</td>
                              <td>{data?.contactNumber}</td>
                              <td class="fw-bold text--warning">
                                {" "}
                                {data?.rasidNo}
                              </td>
                              <td>
                                {moment(data?.sellinDate).format(
                                  " DD/MM/YYYY "
                                )}
                              </td>
                              <td class="fw-bold text--warning">
                                {" "}
                                <Tooltip title="View">
                                  <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                      navigate("/owner-details/" + data?._id);
                                    }}
                                  >
                                    <SvgIcon.Visibility className="scale-icon edit-icon" />
                                  </span>
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}

                {pastOwnerList?.length > 0 && (
                  <p>
                    <span style={{ fontWeight: "bold" }}>Past Owner</span> :{" "}
                  </p>
                )}

                {pastOwnerList?.length > 0 && (
                  <table class="table table-striped table-bordered">
                    <tbody>
                      <tr>
                        <td class="fw-bold">Onwer Name</td>
                        <td class="fw-bold">Father's/Husband's Name</td>
                        <td class="fw-bold">Address</td>
                        <td class="fw-bold">Mobile No.</td>
                        <td class="fw-bold">Recept No. </td>
                        <td class="fw-bold">Sell in Date </td>
                        <td class="fw-bold">View </td>
                      </tr>

                      {pastOwnerList &&
                        pastOwnerList?.map((data, i) => {
                          return (
                            <tr>
                              <td>{data?.userName}</td>
                              <td>{data?.userFather}</td>
                              <td>{data?.Address}</td>
                              <td>{data?.contactNumber}</td>
                              <td class="fw-bold text--warning">
                                {" "}
                                {data?.rasidNo}
                              </td>
                              <td>
                                {" "}
                                {moment(data?.sellinDate).format(
                                  " DD/MM/YYYY "
                                )}
                              </td>
                              <td class="fw-bold text--warning">
                                {" "}
                                <Tooltip title="View">
                                  <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                      navigate("/owner-details/" + data?._id);
                                    }}
                                  >
                                    <SvgIcon.Visibility className="scale-icon edit-icon" />
                                  </span>
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlotDetails;
